export const TENANT = process.env.REACT_APP_TENANT;
export const ENV = process.env.REACT_APP_ENV;
export const ENVIROMENT_NAME =
  process.env.REACT_APP_ENVIROMENT_NAME ?? (TENANT + (ENV === "prod" || ENV === "live" ? "" : " " + ENV));
export const TESTING_FUNCTIONALITY = process.env.REACT_APP_TESTING === "true";
export const STORE_USER_EDITS = process.env.REACT_APP_STORE_USER_EDITS === "true";
export const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME ?? "Oscar & Clothilde";
export const MFA_ENABLED = process.env.REACT_APP_MFA_ENABLED === "true";

//helpers/parsers
const toNumber = (v: string | undefined, fallback: number) => {const n = Number.parseFloat(v ?? "");return Number.isFinite(n) ? n : fallback;};
const toNumberArray = (v: string | undefined, fallback: number[]) => {if (!v?.trim()) return fallback;
  const values = v.split(',').map(x => Number.parseInt(x.trim(), 10)).filter(Number.isFinite);
  return values.length ? values : fallback;
};

// ---- Server Version Gating ----

// Default to 1 so older builds are safe by default
export const SERVER_VERSION = toNumber(process.env.REACT_APP_SERVER_VERSION, 1);

// Feature gates
export const canUseDiscontinuedToggle = SERVER_VERSION >= 2;
export const canUseCustomerKeyValuePairs = SERVER_VERSION >= 2;
export const shippedDashboardEndpointNeedWarehouseId = SERVER_VERSION < 3;
export const showDispatchOrdersInMenu = SERVER_VERSION >= 4;

// Optional generic helper for future reuse
export const isServerAtLeast = (minVersion: number) => SERVER_VERSION >= minVersion;

export const ONLINE_WAREHOUSE_IDS = toNumberArray(process.env.REACT_APP_ONLINE_WAREHOUSE_IDS,[12]);

export const STORE_WAREHOUSE_IDS = toNumberArray(process.env.REACT_APP_STORE_WAREHOUSE_IDS,[20]);